import { defineStore } from 'pinia'

// Types
interface AccessAllowed {
  regions: string[]
  manufacturers: string[]
  groups: string[]
  dealerships: {
    id: number
    name: string
    manufacturers: number[]
  }[]
}

export const useAuthorizationStore = defineStore('authorizationStore', {
  state: (): {
    roles: string[]
    accessAllowed: AccessAllowed
  } => ({
    roles: [],
    accessAllowed: {
      regions: [],
      manufacturers: [],
      groups: [],
      dealerships: []
    }
  }),

  actions: {
    /**
     * Updates user roles
     * @param roles - Array of role strings
     */
    updateRoles(roles: string[]): void {
      this.roles = roles
    },

    /**
     * Updates access allowed for user
     * @param access - Access object with regions, manufacturers, groups, and dealerships
     */
    updateAccessAllowed(access: AccessAllowed): void {
      this.accessAllowed = access
    }
  }
})
